//Dependencies
import { Button, Form, Input, Loading } from '@gpstrackit/react-controls';
import { Grid, Paper } from '@mui/material';
import { useIntl } from 'react-intl';
//Logos
import logo from 'Assets/images/banner.png';
import google from 'Assets/images/google.svg';
import logoSecundary from 'Assets/images/verticalLogo.png';

//helpers
import {
    ErrorHandlerLogin
} from 'Core/data/Helpers';

import { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";

//Actions
import { forgotPasswordRequest, clearRedux } from 'Redux/actions';
//Notification
import {
    NotificationManager
} from "Components/Notifications";


//Styles
import './forgotPassword.scss';

const currentDomain = window.location.hostname === "localhost" ? `http://localhost:3000` : `https://${window.location.hostname}`;

const ForgotPasswordView = () => {
    const { messages } = useIntl()
    //Ref
    const formRef = useRef();
    const queryParams = new URLSearchParams(location.search);

    const email = queryParams.get('email');
    const confirmationCode = queryParams.get('confirmationCode');
    const username = queryParams.get('username');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    //Local States
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);

    //Redux States
    const { loading, error, resultChangePassword } = useSelector(state => state.forgotPasswordRedux);

    const handleForgotPassword = () => {
        if (password !== confirmPassword) {
            setConfirmPasswordError(true);
            return;
        }
        dispatch(forgotPasswordRequest(username?.trim(), confirmationCode, password?.trim(), navigate));
    }

    useEffect(() => {
        if (resultChangePassword) {
            dispatch(clearRedux("FORGOT_PASSWORD"));
            if (resultChangePassword?.success) {
                setPassword("");
                setConfirmPassword("");
                navigate('/login');
            } else if (!resultChangePassword?.success) {
                NotificationManager.error(resultChangePassword.message, messages['forgot_password_error'], 5000);
            }
            
        }
    }, [resultChangePassword])

    return (
        <div className='forgotPassword-view'>
            {loading && <Loading overlay show />}
            <Grid>
                <Paper elevation={2} className="forgotPassword-view-container-paper">
                    <div className="forgotPassword-view-image">
                        <img src={logo} alt="fireSpot" />
                    </div>
                    <div className="forgotPassword-view-form">
                        <Grid container justifyContent='center' style={{ marginBottom: 35 }}>
                            <Grid item xs={12} style={{ textAlign: 'center', margin: '20px 0' }}>
                                <img src={logoSecundary} style={{ width: 150 }} />
                            </Grid>
                            <div style={{ width: '100%', padding: '10px 10px 10px 10px', textAlign: 'center', fontSize: 14, fontWeight: 500 }}>
                                <span>{messages['forgot_password_confirm_new_password']}</span>
                            </div>
                            <div style={{ width: '100%', padding: '0 30px' }}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => {
                                        handleForgotPassword();
                                    }}
                                >
                                    <div style={{ marginTop: 10 }}>
                                        <Input
                                            label={messages['forgot_password_email']}
                                            placeholder={messages['forgot_password_email']}
                                            type="text"
                                            value={email}
                                            requiredMessage={messages['forgot_password_required_filed']}
                                            disabled={true}
                                        />
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                        <Input
                                            required
                                            label={messages['forgot_password_password']}
                                            placeholder={messages['forgot_password_password']}
                                            type="password"
                                            value={password}
                                            onChange={(e) => {
                                                setPassword(e);
                                            }}
                                            requiredMessage={messages['forgot_password_required_filed']}
                                        />
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                        <Input
                                            required
                                            label={messages['forgot_password_confirm_password']}
                                            placeholder={messages['forgot_password_confirm_password']}
                                            type="password"
                                            value={confirmPassword}
                                            onChange={(e) => {
                                                setConfirmPassword(e);
                                            }}
                                            requiredMessage={messages['forgot_password_required_filed']}
                                        />
                                    </div>
                                    {
                                        error &&
                                        <p style={{ color: 'red', textAlign: 'center', fontSize: 12, marginTop: 10 }} >{ErrorHandlerLogin(error)}</p>
                                    }
                                    {
                                        confirmPasswordError &&
                                        <p style={{ color: 'red', textAlign: 'center', fontSize: 12, marginTop: 10 }} >{messages['forgot_password_confirm_password_error']}</p>
                                    }
                                    <div style={{ marginTop: 10, textAlign: 'center' }}>
                                        <Button
                                            className="btn-dark-blue"
                                            type="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setConfirmPasswordError(false);
                                                formRef.current.submit();
                                            }}
                                            style={{ width: '100%' }}
                                        >
                                            {messages['forgot_password_change_password']}
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Grid>
                    </div>
                </Paper>
            </Grid>
        </div>
    )
}
export default ForgotPasswordView;